import React, { memo, useState, useContext, useMemo } from 'react'
import './EventView.scss'

import { SPContext } from '../../SPContext'

import { Container, Row, Col, Button, UncontrolledTooltip } from 'reactstrap'
import moment from 'moment'
import PageLoading from '../helpers/PageLoading'
import Axios from 'axios'
import ConfirmDialogModal from '../confirm_dialog/ConfirmDialogModal'
import Comments from '../comments/Comments'
import EventEdit from './EventEdit'

const logView = (uri, token, event_id) => {
  // console.log('viewing event #' + event_id)
  const params = new FormData()
  params.append('event_id', event_id)
  params.append('token', token)
  Axios.post(`${uri}Event_Viewed`, params)
}

const getComments = (uri, token, event_id, setComments) => {
  Axios.get(`${uri}Event_Comment/event/${event_id}?token=${token}`).then(
    response => {
      setComments(response.data.data)
    }
  )
}
let mounted = false
const DateIsNull = value => value === '0000-00-00 00:00:00'
const EventView = memo(
  ({
    uri,
    events,
    users,
    eventInterestedPost,
    eventGoingPost,
    eventLikePost,
    user_id,
    locations,
    match,
    token,
    event_types,
    isAdmin
  }) => {
    const [showMoreGoing, setShowMoreGoing] = useState(100)
    const [showMoreInterested, setShowMoreInterested] = useState(10)

    const [open_confirm_dialog, setOpenConfirmDialog] = useState(false)
    const [confirm_dialog_title, setConfirmDialogTitle] = useState(false)
    const [confirm_dialog_content, setConfirmDialogContent] = useState(false)
    const [confirm_dialog_user_id, setConfirmDialogUserId] = useState(0)

    const [ev_comments, setComments] = useState([])

    const getUser = user_id => {
      const user = (users &&
        users.find(u => parseInt(u.id, 10) === parseInt(user_id, 10))) || {
        fist_name: '',
        last_name: ''
      }
      return (
        (user && {
          ...user,
          label: user.first_name + ' ' + user.last_name
        }) ||
        {}
      )
    }

    const event =
      match.params.id && events.find(e => e.event_id === match.params.id)

    useMemo(() => {
      if (event) {
        logView(uri, token, event.event_id)
        getComments(uri, token, event.event_id, setComments)
        mounted = true
      } else {
        // alert("moo");
        // window.location.href = window.location.origin
      }
    }, [match.params.id])

    if (!mounted && event) {
      logView(uri, token, event.event_id)
      getComments(uri, token, event.event_id, setComments)
      mounted = true
    }

    if (!event) return <PageLoading />
    if (!event) {
      // alert("moo2");
      // window.location.href = window.location.origin
    }

    const payment_type =
      (event.event_FK_event_price_type_id &&
        event_types.length &&
        event_types.find(et => et.id === event.event_FK_event_price_type_id)) ||
      {}

    const UsersGoing = ({ action }, props) => {
      let lc_going

      if (action === 'going') {
        if (event && event.going) {
          lc_going = [...event.going]
        }
      } else {
        if (event && event.interested) {
          lc_going = [...event.interested]
        }
      }
      const getUserGoing = lc_user_id => {
        const user = (users &&
          users.find(u => {
            return parseInt(u.id, 10) === lc_user_id
          })) || {
          fist_name: '',
          last_name: ''
        }
        return (
          (user && {
            ...user,
            label: user.first_name + ' ' + user.last_name
          }) ||
          {}
        )
      }

      const staff_image_default = '/images/staff/staff.png'

      const staffImageError = e => {
        e.target.src = staff_image_default
      }

      const userGoing = (lc_user_id, image_staff) => (
        <div className="m-1" key={`avatar-user-${lc_user_id}`}>
          <div
            className={
              'sp-event-view-user-image' +
              (isAdmin && event.event_FK_event_status_id !== '5'
                ? action === 'going'
                  ? ' sp-event-view-user-image-hover'
                  : event.going.length < event.event_needed_max &&
                    event.interested.length > 0
                  ? ' sp-event-view-user-image-hover'
                  : ' '
                : '')
            }
          >
            {(isAdmin && event.event_FK_event_status_id !== '5' && (
              <i
                className={`fas ${
                  action === 'going'
                    ? 'fa-user-times sp-event-view-remove-user'
                    : event.going.length < event.event_needed_max ||
                      event.interested.length > 0
                    ? ' fa-user-plus sp-event-view-transfer-user'
                    : ''
                }`}
              />
            )) ||
              null}

            <img
              width={50}
              height={50}
              src={image_staff}
              onError={staffImageError}
              alt="in"
              id={`avatar-${lc_user_id}`}
              onClick={
                (isAdmin &&
                  event.event_FK_event_status_id !== '5' &&
                  action === 'going' &&
                  (e => removeUserFromEvent(e, lc_user_id))) ||
                (action === 'interested' &&
                  (e => addUserFromEvent(e, lc_user_id))) ||
                null
              }
            />
            <UncontrolledTooltip
              placement="top"
              target={`avatar-${lc_user_id}`}
            >
              {getUserGoing(parseInt(lc_user_id, 10)).label}
            </UncontrolledTooltip>
          </div>
        </div>
      )

      return (
        <Row className="mt-2 sp-event-view-users-going">
          <Col>
            {event && (action === 'going' ? event.going : event.interested)
              ? lc_going
                  .slice(
                    0,
                    action === 'going' ? showMoreGoing : showMoreInterested
                  )
                  .map((lc_user_id, ix) => {
                    const image_staff =
                      '/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
                      lc_user_id +
                      '.jpg'

                    return userGoing(lc_user_id, image_staff)
                  })
              : null}
          </Col>
        </Row>
      )
    }

    const confirmUserDelete = (e, confirmed) => {
      if (confirmed) {
        eventGoingPost(event.event_id, false, confirm_dialog_user_id)
      }
      setOpenConfirmDialog(false)
    }

    const removeUserFromEvent = (e, lc_user_id) => {
      setConfirmDialogTitle('Remove user')
      setConfirmDialogContent(() => (
        <div>
          <span>
            Are you sure you want to remove{' '}
            <strong>{getUser(lc_user_id).label}</strong> from this event?
          </span>
          <p />
          <div className="mt-1 text-center sp-dialog-center-content">
            <img
              width={50}
              height={50}
              className="sp-event-view-user-image"
              src={
                '/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
                lc_user_id +
                '.jpg'
              }
              alt="I'm going"
            />
          </div>
        </div>
      ))
      setConfirmDialogUserId(lc_user_id)
      setOpenConfirmDialog(true)
    }

    const addUserFromEvent = (e, lc_user_id) => {
      eventGoingPost(event.event_id, true, lc_user_id)
    }

    const handleShowMoreGoing = () => {
      setShowMoreGoing(showMoreGoing + 10)
    }

    const handleShowMoreInterested = () => {
      setShowMoreInterested(showMoreInterested + 10)
    }

    const getLocation = () => {
      if (
        event.event_town &&
        event.event_town !== 'null' &&
        event.event_town.length > 0
      ) {
        return event.event_town
      } else {
        if (event) {
          const lc_location = locations.find(
            location_item =>
              parseInt(location_item.id, 10) ===
              parseInt(event.event_FK_location_id, 10)
          )

          return lc_location ? lc_location['value'] : 'N/A'
        }
      }
    }

    let attendee_contribution = 0
    if (event && event.event_cost_individual > 0) {
      attendee_contribution =
        event.event_cost_individual -
        event.event_company_contribution_per_person
    }

    return (
      <section className="sp-event-view">
        <div className="sp-event-view-header" />
        <React.Fragment>
          {/* <div>{JSON.stringify(event)}</div> */}
          <Container>
            <Row>
              <Col xs={{ size: 12, order: 2 }} lg={{ size: 7 }}>
                <Row>
                  <Col>
                    <h1 className="event-name mb-3">{event.event_title}</h1>
                  </Col>
                </Row>
                <Row className="booking-info">
                  <Col md="4">
                    <strong>
                      <img src="/images/calendar.svg" alt="Calendar" />{' '}
                      {moment(event.event_date_start).format('DD MMM')}
                    </strong>{' '}
                    {(!DateIsNull(event.event_response_deadline) && (
                      <span>
                        (Book by{' '}
                        {moment(event.event_response_deadline).format('DD MMM')}
                        )
                      </span>
                    )) ||
                      null}
                  </Col>
                  <Col md="4">
                    <img src="/images/location.svg" alt="Location" />{' '}
                    {getLocation()}
                  </Col>
                  {event.event_related_website ? (
                    <Col md="4">
                      <img src="/images/website.svg" alt="Website" />{' '}
                      <a
                        target="_blank"
                        rel="noopener noreferrer"
                        href={event.event_related_website}
                      >
                        View Website
                      </a>
                    </Col>
                  ) : null}
                </Row>

                <Row>
                  <Col className="mt-3">
                    <p
                      dangerouslySetInnerHTML={{
                        __html: event.event_summary_value
                      }}
                    />
                    {event.event_description_value &&
                      ((
                        <p
                          dangerouslySetInnerHTML={{
                            __html: event.event_description_value
                          }}
                        />
                      ) ||
                        null)}
                  </Col>
                </Row>

                {(event.event_company_contribution && (
                  <Row>
                    <Col>
                      <strong>
                        This is a <span className="sponsored">sponsored</span>{' '}
                        event!
                      </strong>{' '}
                      {(event.event_company_contribution_per_person && (
                        <React.Fragment>
                          <strong>
                            The total cost per person is{' '}
                            <span className="blue">
                              £
                              {(event.event_cost_individual > 0 &&
                                event.event_cost_individual) ||
                                event.event_company_contribution_per_person}
                            </span>{' '}
                            and plan.com is contributing{' '}
                            <span className="blue">
                              £{event.event_company_contribution_per_person}
                            </span>{' '}
                            per plan.com person! The attendee contribution
                            amount is{' '}
                            <span className="blue">
                              £{attendee_contribution.toFixed(2)}
                            </span>
                            .
                          </strong>
                        </React.Fragment>
                      )) ||
                        'The amount of the contribution is to be determined.'}
                    </Col>
                  </Row>
                )) ||
                  null}

                {(!event.event_company_contribution &&
                  event.event_cost_individual &&
                  event.event_cost_individual > 0 && (
                    <Row className="mt-2">
                      <Col>
                        Estimated cost per person*:{' '}
                        <span className="blue">
                          £{event.event_cost_individual}
                        </span>
                        <br />
                      </Col>
                      <Col>
                        <small className="mt-3">
                          *Price excludes plan.com contributions and payment
                          terms are set by the event organiser. Deposits for
                          some events may be required in advance
                        </small>
                      </Col>
                    </Row>
                  )) ||
                  null}
                <hr />
                <Row>
                  <Col>
                    <strong>
                      Here's who wants to go so far:{' '}
                      <span className="blue">{event.going.length} people</span>
                    </strong>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-2 mb-2">
                    <UsersGoing action="going" />
                  </Col>
                </Row>

                {(showMoreGoing < event.going.length && (
                  <Row>
                    <Col className="show-more">
                      <Button
                        color=""
                        onClick={handleShowMoreGoing}
                        disabled={showMoreGoing >= event.going.length}
                      >
                        show more
                      </Button>
                    </Col>
                  </Row>
                )) ||
                  null}

                {(event.going.length >= event.event_needed_max ||
                  event.interested.length > 0) && (
                  <>
                    <hr />
                    <Row>
                      <Col>
                        <strong>
                          Here's who is interested too:{' '}
                          <span className="blue">
                            {event.interested.length} people
                          </span>
                        </strong>
                      </Col>
                    </Row>
                    <Row>
                      <Col className="mt-2 mb-2">
                        <UsersGoing action="interested" />
                      </Col>
                    </Row>
                    {(showMoreInterested < event.interested.length && (
                      <Row>
                        <Col className="show-more">
                          <Button
                            color=""
                            onClick={handleShowMoreInterested}
                            disabled={
                              showMoreInterested >= event.interested.length
                            }
                          >
                            show more
                          </Button>
                        </Col>
                      </Row>
                    )) ||
                      null}
                  </>
                )}

                <Row className="mt-3">
                  <Col>
                    <h3>Event location</h3>
                  </Col>
                </Row>
                <Row>
                  <Col className="mt-3 mb-5">
                    {(event.event_map_link && (
                      <div
                        className="map"
                        dangerouslySetInnerHTML={{
                          __html: event.event_map_link
                        }}
                      />
                    )) ||
                      null}
                  </Col>
                </Row>

                <Row className="mt-3 mb-4">
                  <Col>
                    <Comments
                      event={event}
                      ev_comments={ev_comments}
                      setComments={setComments}
                    />
                  </Col>
                </Row>
              </Col>
              <Col
                xs={{ size: 12 }}
                lg={{ size: 4, offset: 1, order: 2 }}
                className="mb-2 sp-event-view-field"
              >
                <Row>
                  <Col className="sp-event-view-img mb-3">
                    <EventEdit item_event={event} />
                    {(event.main_image && (
                      <img
                        src={event.main_image}
                        alt=""
                        className="img-fluid"
                      />
                    )) ||
                      null}
                    <img
                      alt={payment_type.label}
                      src={`/images/payment-${payment_type.id}.png`}
                      className="funded"
                    />
                  </Col>
                </Row>

                <Row>
                  <Col xs="2">
                    <div className="sp-event-view-user-image">
                      <img
                        width={50}
                        height={50}
                        src={
                          '/timthumb.php?width=50&height=50&src=https://socialfiles.blob.core.windows.net/staff/' +
                          event.event_FK_created_by_user_id +
                          '.jpg'
                        }
                        alt="I'm going"
                      />
                    </div>
                  </Col>
                  <Col xs="6">
                    <Row className="mt-2">
                      <Col className="organiser">Event organiser</Col>
                    </Row>
                    <Row>
                      <Col>
                        <strong>
                          <h5>
                            {getUser(event.event_FK_created_by_user_id).label}
                          </h5>
                        </strong>
                      </Col>
                    </Row>
                  </Col>
                  <Col xs="4">
                    <Row className="mt-2">Viewed</Row>
                    <Row>
                      <Col>
                        <strong>{event.viewed}</strong>
                      </Col>
                    </Row>
                  </Col>
                </Row>

                {/* <Row>
        <Col className="mt-3">
          <small>
            Want to know more? Have a chat with <a href="">Mike</a> :)
          </small>
        </Col>
      </Row> */}
                <hr />

                <Row className="event-actions-row">
                  <Col xs="2">
                    <div
                      className={
                        'sp-event-view-like-button ' +
                        (event.event_FK_event_status_id === '5'
                          ? 'disabled'
                          : 'pointer') +
                        ((!!~event.likes.indexOf(user_id) && ' like') || '')
                      }
                      onClick={() =>
                        event.event_FK_event_status_id !== '5' &&
                        eventLikePost(
                          event.event_id,
                          !~event.likes.indexOf(user_id)
                        )
                      }
                    >
                      <img src="/images/heart.svg" alt="Like" />
                    </div>
                  </Col>
                  <Col xs="4">
                    <span className="sp-event-view-like-message">
                      {(!!~event.likes.indexOf(user_id) &&
                        'I like this event') ||
                        'Like this event'}
                    </span>
                  </Col>

                  {(event.going.length >= event.event_needed_max &&
                    !!!~event.going.indexOf(user_id) && (
                      // <Col xs="6">
                      //   <span className="sp-event-view-going-message">
                      //     Event fully booked.
                      //   </span>
                      // </Col>

                      <React.Fragment>
                        <Col xs="2">
                          <div
                            className={
                              'sp-event-view-interested-button' +
                              (event.event_FK_event_status_id === '5'
                                ? 'disabled'
                                : 'pointer') +
                              ((!!~event.interested.indexOf(user_id) &&
                                ' interested') ||
                                '')
                            }
                            onClick={() =>
                              event.event_FK_event_status_id !== '5' &&
                              eventInterestedPost(
                                event.event_id,
                                !~event.interested.indexOf(user_id)
                              )
                            }
                          >
                            <img src="/images/star.svg" alt="Like" />
                          </div>
                        </Col>
                        <Col xs="4">
                          <span className="sp-event-view-interested-message">
                            {(!!~event.interested.indexOf(user_id) &&
                              "I'm interested!") ||
                              'Not Interested'}
                          </span>
                        </Col>
                      </React.Fragment>
                    )) || (
                    <React.Fragment>
                      <Col xs="2">
                        <div
                          className={
                            'sp-event-view-going-button ' +
                            (event.event_FK_event_status_id === '5'
                              ? 'disabled'
                              : 'pointer') +
                            ((!!~event.going.indexOf(user_id) && ' going') ||
                              '')
                          }
                          onClick={() =>
                            event.event_FK_event_status_id !== '5' &&
                            eventGoingPost(
                              event.event_id,
                              !~event.going.indexOf(user_id)
                            )
                          }
                        >
                          <img src="/images/avatar.svg" alt="Like" />
                        </div>
                      </Col>
                      <Col xs="4" className="view-going-message-container">
                        <span className="sp-event-view-going-message">
                          {(!!~event.going.indexOf(user_id) &&
                            'I want to go!') ||
                            "I don't want to go"}
                        </span>
                      </Col>
                    </React.Fragment>
                  )}
                </Row>
                <hr />
                <Row className="mt-3">
                  <Col xs="6">Kid friendly?</Col>
                  <Col xs="6">
                    <strong>
                      {(event.event_family_welcome && 'Yes') || 'Nope'}
                    </strong>
                  </Col>
                </Row>
                <hr />
                {/* <Row className="mt-3">
        <Col xs="5">Friends welcome?</Col>
        <Col xs="2">
        <strong>{(event.event_friends_welcome && 'Yes') || 'Nope'}</strong>
        </Col>
      </Row> */}
                <Row className="mt-3">
                  <Col xs="6">Age limit?</Col>
                  <Col xs="6">
                    <strong>
                      {(parseInt(event.event_age_limit, 10) === 1 &&
                        'No limit') ||
                        null}
                      {(parseInt(event.event_age_limit, 10) === 2 &&
                        'Over 18') ||
                        null}
                      {(parseInt(event.event_age_limit, 10) === 3 &&
                        'Over 21') ||
                        null}
                    </strong>
                  </Col>
                </Row>
                <hr />
                <Row className="mt-3">
                  <Col xs="6">Personal holiday required?</Col>
                  <Col xs="6">
                    <strong>
                      {(event.event_holiday_required && 'Yes') || 'Nope'}
                    </strong>
                    <br />
                    <small>
                      Line manager permission must be obtained in advance
                    </small>
                  </Col>
                </Row>
              </Col>
            </Row>
          </Container>
        </React.Fragment>
        <ConfirmDialogModal
          isOpen={open_confirm_dialog}
          title={confirm_dialog_title}
          content={confirm_dialog_content}
          fnAction={confirmUserDelete}
          isProcessing={false}
        />
      </section>
    )
  }
)

const EventViewContainer = props => {
  const {
    uri,
    events,
    users,
    eventInterestedPost,
    eventGoingPost,
    eventLikePost,
    user_id,
    categories,
    travels,
    locations,
    token,
    event_types,
    isAdmin
  } = useContext(SPContext)
  return (
    <EventView
      uri={uri}
      events={events}
      users={users}
      eventInterestedPost={eventInterestedPost}
      eventGoingPost={eventGoingPost}
      eventLikePost={eventLikePost}
      user_id={user_id}
      categories={categories}
      travels={travels}
      locations={locations}
      token={token}
      event_types={event_types}
      isAdmin={isAdmin}
      {...props}
    />
  )
}

export default EventViewContainer
